import { render, staticRenderFns } from "./AttachmentPriceSetting.vue?vue&type=template&id=7f45a346&scoped=true&"
import script from "./AttachmentPriceSetting.vue?vue&type=script&lang=ts&"
export * from "./AttachmentPriceSetting.vue?vue&type=script&lang=ts&"
import style0 from "./AttachmentPriceSetting.vue?vue&type=style&index=0&id=7f45a346&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f45a346",
  null
  
)

export default component.exports